__turbopack_context__.v({
  "burst-down": "thinking-loader-module__1IHlUG__burst-down",
  "burst-left": "thinking-loader-module__1IHlUG__burst-left",
  "burst-right": "thinking-loader-module__1IHlUG__burst-right",
  "burst-up": "thinking-loader-module__1IHlUG__burst-up",
  "burstDown": "thinking-loader-module__1IHlUG__burstDown",
  "burstLeft": "thinking-loader-module__1IHlUG__burstLeft",
  "burstRight": "thinking-loader-module__1IHlUG__burstRight",
  "burstUp": "thinking-loader-module__1IHlUG__burstUp",
  "compass": "thinking-loader-module__1IHlUG__compass",
  "compassMover": "thinking-loader-module__1IHlUG__compassMover",
  "corners-a": "thinking-loader-module__1IHlUG__corners-a",
  "corners-b": "thinking-loader-module__1IHlUG__corners-b",
  "corners-c": "thinking-loader-module__1IHlUG__corners-c",
  "corners-d": "thinking-loader-module__1IHlUG__corners-d",
  "cornersA": "thinking-loader-module__1IHlUG__cornersA",
  "cornersB": "thinking-loader-module__1IHlUG__cornersB",
  "cornersC": "thinking-loader-module__1IHlUG__cornersC",
  "cornersD": "thinking-loader-module__1IHlUG__cornersD",
  "frame": "thinking-loader-module__1IHlUG__frame",
  "glow": "thinking-loader-module__1IHlUG__glow",
  "gradInner": "thinking-loader-module__1IHlUG__gradInner",
  "gradOuter": "thinking-loader-module__1IHlUG__gradOuter",
  "inheritInk": "thinking-loader-module__1IHlUG__inheritInk",
  "label": "thinking-loader-module__1IHlUG__label" + " " + __turbopack_context__.i(1931122)["shimmer"],
  "label-out": "thinking-loader-module__1IHlUG__label-out",
  "label-reveal": "thinking-loader-module__1IHlUG__label-reveal",
  "labelIn": "thinking-loader-module__1IHlUG__labelIn",
  "labelLayer": "thinking-loader-module__1IHlUG__labelLayer",
  "labelOut": "thinking-loader-module__1IHlUG__labelOut",
  "labelRow": "thinking-loader-module__1IHlUG__labelRow",
  "labelStack": "thinking-loader-module__1IHlUG__labelStack",
  "labelStatic": "thinking-loader-module__1IHlUG__labelStatic",
  "metaballs-a": "thinking-loader-module__1IHlUG__metaballs-a",
  "metaballs-b": "thinking-loader-module__1IHlUG__metaballs-b",
  "metaballsA": "thinking-loader-module__1IHlUG__metaballsA",
  "metaballsB": "thinking-loader-module__1IHlUG__metaballsB",
  "relay": "thinking-loader-module__1IHlUG__relay",
  "relay-wide-wave": "thinking-loader-module__1IHlUG__relay-wide-wave",
  "relayActivityBlock": "thinking-loader-module__1IHlUG__relayActivityBlock",
  "relayActivityBlockFourth": "thinking-loader-module__1IHlUG__relayActivityBlockFourth",
  "relayActivityBlockSecond": "thinking-loader-module__1IHlUG__relayActivityBlockSecond",
  "relayActivityBlockThird": "thinking-loader-module__1IHlUG__relayActivityBlockThird",
  "relayActivityTrack": "thinking-loader-module__1IHlUG__relayActivityTrack",
  "relayBall": "thinking-loader-module__1IHlUG__relayBall",
  "relayCapExtension": "thinking-loader-module__1IHlUG__relayCapExtension",
  "relayCapFrame": "thinking-loader-module__1IHlUG__relayCapFrame",
  "relayLeftCap": "thinking-loader-module__1IHlUG__relayLeftCap",
  "relayLeftCapFrame": "thinking-loader-module__1IHlUG__relayLeftCapFrame",
  "relayRightCap": "thinking-loader-module__1IHlUG__relayRightCap",
  "relayRightCapFrame": "thinking-loader-module__1IHlUG__relayRightCapFrame",
  "relayWideLayout": "thinking-loader-module__1IHlUG__relayWideLayout",
  "squeeze-l": "thinking-loader-module__1IHlUG__squeeze-l",
  "squeeze-r": "thinking-loader-module__1IHlUG__squeeze-r",
  "squeezeBarL": "thinking-loader-module__1IHlUG__squeezeBarL",
  "squeezeBarR": "thinking-loader-module__1IHlUG__squeezeBarR",
  "stage": "thinking-loader-module__1IHlUG__stage",
  "stageActive": "thinking-loader-module__1IHlUG__stageActive",
  "think-a": "thinking-loader-module__1IHlUG__think-a",
  "think-b": "thinking-loader-module__1IHlUG__think-b",
  "think-c": "thinking-loader-module__1IHlUG__think-c",
  "thinkA": "thinking-loader-module__1IHlUG__thinkA",
  "thinkB": "thinking-loader-module__1IHlUG__thinkB",
  "thinkC": "thinking-loader-module__1IHlUG__thinkC",
});
